<template>
  <v-dialog v-model="show" width="500px">
    <ModalContentPosting :onclose="close" />
  </v-dialog>
</template>

<script>
import ModalContentPosting from './ModalContentPosting.vue';

export default {
  data() {
    return {
      show: false,
    };
  },
  components: {
    ModalContentPosting,
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
};
</script>
